var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-master',{attrs:{"name":_vm.master.endpoint,"endpoint":_vm.master.endpoint,"tableSetup":_vm.master.tableSetup,"actions":false},scopedSlots:_vm._u([{key:"expandedRowRender",fn:function(ref){
var text = ref.text;
return [_vm._l((_vm.master.valoresExpandidos),function(ve){return [_vm._v("\n      "+_vm._s(ve.label)+": "),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(text[ve.column]))]),_c('br')]})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53db74ab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/Nomina/Novedades/OvertimeHist.vue
// module id = null
// module chunks = 